<template>
	<v-card>
		<v-card-title
			class="d-flex align-center"
		>
			<v-icon
				icon="$test"
				start
			/>
			<translate>
				A/B Tests
			</translate>
			<v-spacer />
			<a-b-test-setup
				ref="setup"
				:product-id="productId"
				@new-test="index"
			>
				<template #activator="{ props }">
					<v-btn
						v-if="!readonly"
						v-can="'productversion.create'"
						color="primary"
						v-bind="props"
						variant="flat"
						prepend-icon="$plus"
					>
						<translate>Start A/B Test</translate>
					</v-btn>
				</template>
			</a-b-test-setup>
		</v-card-title>
		<v-card-text
			class="pb-0"
		>
			<model-table
				ref="modelTable"
				v-model:expanded="expanded"
				:headers="headers"
				endpoint="/api/abtests"
				:filter="customFilter"
				show-expand
				item-key="id"
			>
				<template #item.productId="{ item }">
					<a :href="`/bo/products/view?id=${item.productId}`">
						{{ item.productId }}
					</a>
				</template>
				<template #item.swapFrequency="{ item }">
					{{ item.swapFrequency }}
					<translate>
						days
					</translate>
				</template>
				<template #item.startDate="{ item }">
					{{ (new Date(item.startDate.date)).toDateString() }}
				</template>
				<template #item.endDate="{ item }">
					{{ (new Date(item.endDate.date)).toDateString() }}
				</template>
				<template #item.actions="{ item }">
					<confirm-dialog @confirm="stop(item)">
						<template #activator="{ props }">
							<v-btn
								v-can="'productversion.create'"
								variant="text"
								color="error"
								v-bind="props"
							>
								<translate>
									Stop
								</translate>
							</v-btn>
						</template>
					</confirm-dialog>
				</template>
				<template #expanded-row="{ columns, item }">
					<table>
						<tr>
							<th :colspan="columns.length">
								<translate>
									Product Versions
								</translate>
							</th>
						</tr>
						<tr
							v-for="productversion in item.productversions"
							:key="productversion.id"
						>
							<td :colspan="columns.length">
								<translate>Version</translate> {{ productversion.id }}
							</td>
						</tr>
					</table>
				</template>
			</model-table>
		</v-card-text>
	</v-card>
</template>
<script>
import ModelTable from './ModelTable.vue';
import {
	axios,
} from '../../services/axios-service';
import ConfirmDialog from './ConfirmDialog.vue';
import ABTestSetup from '../organisms/ABTestSetup.vue';

export default {
	name: 'ABTestList',
	components: {
		ABTestSetup,
		ConfirmDialog,
		ModelTable
	},

	props: {
		productId: {
			type: Number,
			required: false,
			default: 0
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data () {
		return {
			expanded: []
		};
	},

	computed: {
		headers () {
			const headers = [];

			if (!this.productId) {
				headers.push({
					title: this.$gettext('Product ID'),
					sortable: true,
					value: 'productId',
				});
			}
			return headers.concat([
				{
					title: this.$gettext('Current Version'),
					sortable: true,
					value: 'currentProductVersion',
				},
				{
					title: this.$gettext('Swap Interval'),
					sortable: true,
					value: 'swapFrequency',
				},
				{
					title: this.$gettext('Start Date'),
					sortable: true,
					value: 'startDate',
					filterable: true,
				},
				{
					title: this.$gettext('End Date'),
					sortable: true,
					value: 'endDate',
					filterable: true,
				},
				{
					title: this.$gettext('Actions'),
					value: 'actions',
				},
			]);
		},
	},

	methods: {
		/**
		 * trigger index on model table
		 */
		index () {
			this.$refs.modelTable.index();
		},

		/**
		 * trigger index on model table
		 */
		updateProductVersions () {
			this.$refs.setup.getProductVersions();
		},

		/**
		 * @param {object} item
		 *
		 * @returns {boolean}
		 */
		customFilter (item) {
			if (this.productId) {
				return item.productId === this.productId;
			}
			return true;
		},

		/**
		 * @param {object} abtest
		 */
		stop (abtest) {
			axios.post(`/api/abtests/stop?id=${abtest.id}`).then(() => {
				this.$refs.modelTable.index();
			});
		},
	}
};
</script>

<style scoped>

</style>
